module.exports = __webpack_public_path__ + "img/earn-count-btn-1.4abdb2ff.png";